import React from 'react';
import AtlasV2DropdownMetricColumnChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DropdownMetricColumnChart';
import { useMainEntityType } from 'src/utils/Hooks/reduxSelectors';

/**
 *
 * Retail Sales top entity chart with single dropdown
 */
const AtlasV2SalesDropdownTopEntityChart = () => {
  const mainEntityType = useMainEntityType();
  return (
    <AtlasV2DropdownMetricColumnChart
      indexName="sales"
      fieldName="retailSales"
      dropdownOptions={[
        {
          id: 'brandId',
          label: 'Brand'
        },
        {
          id: 'categoryId',
          label: 'Category'
        },
        {
          id: 'subCategoryId',
          label: 'Subcategory'
        },

        {
          id: 'parentBrandId',
          label: 'Manufacturer'
        }
      ].filter((option) => !option.id.toLowerCase().startsWith(mainEntityType))}
      titlePrefix="Retail Sales by"
    />
  );
};
export default AtlasV2SalesDropdownTopEntityChart;
